import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import Link from 'next/link';
export default function LinksAboutUs() {
  return /*#__PURE__*/_jsxs("ul", {
    children: [/*#__PURE__*/_jsx("li", {
      children: /*#__PURE__*/_jsx(Link, {
        href: "/about",
        children: /*#__PURE__*/_jsx("a", {
          children: "Our Story"
        })
      })
    }), /*#__PURE__*/_jsx("li", {
      children: /*#__PURE__*/_jsx(Link, {
        href: "/about/reviews",
        children: /*#__PURE__*/_jsx("a", {
          children: "Reviews"
        })
      })
    }), /*#__PURE__*/_jsx("li", {
      children: /*#__PURE__*/_jsx(Link, {
        href: "/blog",
        children: /*#__PURE__*/_jsx("a", {
          children: "Blog"
        })
      })
    }), /*#__PURE__*/_jsx("li", {
      children: /*#__PURE__*/_jsx(Link, {
        href: "/about/videos",
        children: /*#__PURE__*/_jsx("a", {
          children: "Videos"
        })
      })
    })]
  });
}